import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "shell padding20px" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "height20px" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_user_form = _resolveComponent("user-form")
  const _component_office_form = _resolveComponent("office-form")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      (_ctx.projectType==='community')
        ? (_openBlock(), _createBlock(_component_user_form, {
            key: 0,
            id: _ctx.id,
            commit: _ctx.commit,
            onSubmit: _ctx.submit
          }, null, 8, ["id", "commit", "onSubmit"]))
        : _createCommentVNode("", true),
      (_ctx.projectType==='office')
        ? (_openBlock(), _createBlock(_component_office_form, {
            key: 1,
            id: _ctx.id,
            onSubmit: _ctx.submit,
            commit: _ctx.commit
          }, null, 8, ["id", "onSubmit", "commit"]))
        : _createCommentVNode("", true),
      _hoisted_2,
      _createVNode(_component_cus_button, {
        onClick: _ctx.checkForm,
        type: "blue"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}